module.exports = __webpack_public_path__ + "static/media/unexpected-error.59cfe134.png";